<div class="frontpage-widget cover-image-mose-gray">
    <div class="whitebox gray">
        <div class="container">
            <p class="text-muted">RISIKOVURDERING
                <i class="fa fa-chevron-right"></i>
            </p>
            <h2 i18n>Resultater</h2>
            <p>
                <span class="text-muted">
                    <i class="fa fa-map-marker"></i>Lokalitet:</span>
                <ng-container
                    *ngIf="calculation?.calculationType == calculationType.Standard || calculation?.calculationType == calculationType.V1AsV2Calculation">
                    <a [routerLink]="['/riskassessment/location-details', calculation?.location.id]">
                        {{calculation?.location.name}}
                    </a>
                </ng-container>
                <ng-container *ngIf="calculation?.calculationType == calculationType.PreliminaryCalculation">
                    <a [routerLink]="['/riskassessment/preliminary/location-details', calculation?.location.id]">
                        {{calculation?.location.name}}
                    </a>
                </ng-container>
            </p>
            <p>
                <span class="text-muted">Lokalitetsnummer: </span>
                {{calculation?.location.number}}
            </p>
        </div>
    </div>
</div>

<div class="container mb-5" id="pdfExport" (window:resize)="onResize($event)">
    <div *ngIf="calculationLoading" class="mt-5 text-center">
        <app-load-indicator style="width: 25px; height: 25px;"></app-load-indicator>
        <h3 class="vd-text-muted font-weight-light mb-0 mt-1" i18n>Henter beregninger... </h3>
        <p class="text-muted mt-1">Det tager et øjeblik</p>
    </div>
    <div *ngIf="hasLoadingError" class="mt-5 text-center">
        <h3 class="font-weight-light mb-0 mt-1" i18n><span class="vd-text-muted">Vi fandt ikke beregningen...</span> <i
                class="fa fa-meh-o"></i></h3>
        <p class="text-muted mt-1">Kontakt support...</p>
    </div>
    <div *ngIf="!hasLoadingError" [hidden]="calculationLoading" class="row mt-5">
        <div class="col-sm-12 col-lg-6">
            <div #pdfCalculationHeaderDiv>
                <h4 class="calculation-section-header">
                    <span i18n>
                        <i class="fa fa-calculator"></i> Beregning</span>
                </h4>
                <div class="form-group mt-3">
                    <label for="polutant">Forureningsstof:</label>
                    <div>
                        <span i18n>{{calculation?.calculationInput?.contaminantName}}</span>
                    </div>
                </div>

                <div class="form-group">
                    <label for="polutant">Beregningsmodel:</label>
                    <div class="readonly">
                        <span class="model-indicator">
                            <i class="model-icon"></i>
                            <span class="model-number">{{calculation?.calculationInput?.modelType}}</span>
                        </span>
                        {{calculationModelNames[calculation?.calculationInput?.modelType]}}
                    </div>
                </div>

                <div class="form-group">
                    <label for="polutant">Nedbrydning:</label>
                    <div>
                        <span [ngSwitch]="calculation?.calculationInput?.degradation">
                            <span *ngSwitchCase="degradation.None">Ingen nedbrydning</span>
                            <span *ngSwitchCase="degradation.Simple">1. ordens nedbrydning</span>
                            <span *ngSwitchCase="degradation.Sequential">Sekventiel 1. ordens nedbrydning</span>
                        </span>
                    </div>
                </div>
            </div>

            <div *ngIf="calculationInProgress" class="in-progress-container">
                <span>
                    <div class="progress" style="width:60%; margin:auto;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
                            style="width:100%">Beregning i gang...</div>
                    </div>
                </span>
                <div class="in-progress-button">
                    <button (click)="hotCancelCalculation()" [disabled]="!canRequestCancel" class="btn btn-secondary">Stop beregning</button>
                </div>
            </div>

            <div [hidden]="!calculationFailed" class="alert alert-danger" role="alert">
                <p class="mb-0">
                    <b>
                        <i class="fa fa-exclamation fa-3x" style="float:left; margin-right:0.3rem"></i>
                        Beregningen fejlede - kontakt support:
                    </b>
                    <br>
                    {{calculationFailedErrorMessage}}
                </p>
            </div>

            <div [hidden]="calculationFailed">
                <div [hidden]="!calculationComplete" #pdfCalculationResultsDiv>
                    <h4 class="calculation-section-header mt-5 mb-4">
                        <span i18n>
                            <i class="fa fa-map-marker"></i> Resultater for nedstrøms kontrolpunkter</span>
                    </h4>

                    <div class="vd-card px-4 py-4 " #pdfResultatForKontrolpunkt>
                        <p>
                            <b>Resultat for kontrolpunkt (100 m nedstrøms, 2 m filter)</b>
                        </p>
                        <div class="point-sample-result-group">
                            <ng-container *ngIf="calculationInput?.compoundCount > 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Koncentration:</b>
                                    </label>
                                    <div></div>
                                </div>
                                <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                    <label
                                        for="polutant">{{calculationInput?.degradationChainCompoundNames[i]}}:</label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getNumberWithSignificantDigits(calculation?.calculationResult.pointResults[0].concentration[i])}}
                                            µg/L</span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="calculationInput?.compoundCount == 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Koncentration:</b>
                                    </label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getNumberWithSignificantDigits(calculation?.calculationResult.pointResults[0].concentration[0])}}
                                            µg/L</span>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="spacer"></div>

                            <ng-container *ngIf="calculationInput?.compoundCount > 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Overskridelsesfaktor:</b>
                                    </label>
                                    <div></div>
                                </div>
                                <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                    <label
                                        for="polutant">{{calculationInput?.degradationChainCompoundNames[i]}}:</label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getValidNumber(calculation?.calculationResult.pointResults[0].excessFactor[i]) | number:'1.0-1'}}</span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="calculationInput?.compoundCount == 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Overskridelsesfaktor:</b>
                                    </label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getValidNumber(calculation?.calculationResult.pointResults[0].excessFactor[0]) | number:'1.0-1'}}</span>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="spacer"></div>

                            <ng-container *ngIf="calculationInput?.compoundCount > 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Flux:</b>
                                    </label>
                                    <div></div>
                                </div>
                                <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                    <label
                                        for="polutant">{{calculationInput?.degradationChainCompoundNames[i]}}:</label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getNumberWithSignificantDigits(calculation?.calculationResult.pointResults[0].massDischarge[i])}}
                                            kg/år</span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="calculationInput?.compoundCount == 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Flux:</b>
                                    </label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getNumberWithSignificantDigits(calculation?.calculationResult.pointResults[0].massDischarge[0])}}
                                            kg/år</span>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="spacer"></div>

                            <ng-container *ngIf="calculationInput?.compoundCount > 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Opblandet koncentration i indvinding/fiktiv indvinding:</b>
                                    </label>
                                    <div></div>
                                </div>
                                <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                    <label
                                        for="polutant">{{calculationInput?.degradationChainCompoundNames[i]}}:</label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getNumberWithSignificantDigits(calculation?.calculationResult.pointResults[0].wellConcentration[i])}}
                                            µg/L</span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="calculationInput?.compoundCount == 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Opblandet koncentration i indvinding/fiktiv indvinding:</b>
                                    </label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getNumberWithSignificantDigits(calculation?.calculationResult.pointResults[0].wellConcentration[0])}}
                                            µg/L</span>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="spacer"></div>

                            <ng-container *ngIf="calculationInput?.compoundCount > 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Kvalitetskriterie:</b>
                                    </label>
                                    <div></div>
                                </div>
                                <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                    <label for="polutant">
                                        {{calculationInput?.degradationChainCompoundNames[i]}}:
                                    </label>
                                    <div>
                                        <span class="readonly">
                                            {{getValidNumber(calculationInput?.degradationChainQualityCriteria[i]) | number:'1.0-5'}}
                                            µg/L
                                            {{displayAsteriskMark(calculationInput?.degradationChainQualityCriteriaType, i)}}
                                        </span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="calculationInput?.compoundCount == 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Kvalitetskriterie{{displayAsteriskMark(calculationInput?.degradationChainQualityCriteriaType)}}:</b>
                                    </label>
                                    <div>
                                        <span class="readonly">
                                            {{getValidNumber(calculationInput?.degradationChainQualityCriteria[0]) | number:'1.0-5'}}
                                            µg/L
                                        </span>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="spacer"></div>

                            <div class="form-group">
                                <label for="polutant">Risikovurdering:</label>
                                <div>
                                    <div *ngIf="pointResultIsRisk(0)">
                                        <span class="fa-stack risk-indicator risk-computed">
                                            <span class="icon"></span>
                                        </span>
                                        <span class="readonly">
                                            <b>Risiko</b>
                                        </span>
                                    </div>

                                    <div *ngIf="!pointResultIsRisk(0)">
                                        <span class="fa-stack risk-indicator no-risk-computed">
                                            <span class="icon"></span>
                                        </span>
                                        <span class="readonly">Ingen Risiko</span>
                                    </div>
                                </div>
                            </div>

                            <div class="spacer"></div>
                            <div class="form-group">
                                <label for="polutant"><small>(*) fiktiv værdi er anvendt.</small></label>
                            </div>

                        </div>
                    </div>

                    <div class="px-4 py-4 mt-3" *ngIf="calculationInput?.hasAdditionalPoC" #pdfResultatForValgtKontrolpunkt>
                        <p>
                            <b>Resultat for valgt kontrolpunkt ({{calculationInput?.additionalPoCDistanceFromSource}}m
                                nedstrøms,
                                {{calculationInput?.additionalPoCScreenLength}}m filter)</b>
                        </p>
                        <div class="point-sample-result-group">
                            <ng-container *ngIf="calculationInput?.compoundCount > 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Koncentration:</b>
                                    </label>
                                    <div></div>
                                </div>
                                <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                    <label
                                        for="polutant">{{calculationInput?.degradationChainCompoundNames[i]}}:</label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getNumberWithSignificantDigits(calculation?.calculationResult.pointResults[1].concentration[i])}}
                                            µg/L</span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="calculationInput?.compoundCount == 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Koncentration:</b>
                                    </label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getNumberWithSignificantDigits(calculation?.calculationResult.pointResults[1].concentration[0])}}
                                            µg/L</span>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="spacer"></div>

                            <ng-container *ngIf="calculationInput?.compoundCount > 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Overskridelsesfaktor:</b>
                                    </label>
                                    <div></div>
                                </div>
                                <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                    <label
                                        for="polutant">{{calculationInput?.degradationChainCompoundNames[i]}}:</label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getValidNumber(calculation?.calculationResult.pointResults[1].excessFactor[i]) | number:'1.0-1'}}</span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="calculationInput?.compoundCount == 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Overskridelsesfaktor:</b>
                                    </label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getValidNumber(calculation?.calculationResult.pointResults[1].excessFactor[0]) | number:'1.0-1'}}</span>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="spacer"></div>

                            <ng-container *ngIf="calculationInput?.compoundCount > 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Flux:</b>
                                    </label>
                                    <div></div>
                                </div>
                                <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                    <label
                                        for="polutant">{{calculationInput?.degradationChainCompoundNames[i]}}:</label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getNumberWithSignificantDigits(calculation?.calculationResult.pointResults[1].massDischarge[i])}}
                                            kg/år</span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="calculationInput?.compoundCount == 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Flux:</b>
                                    </label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getNumberWithSignificantDigits(calculation?.calculationResult.pointResults[1].massDischarge[0])}}
                                            kg/år</span>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="spacer"></div>

                            <ng-container *ngIf="calculationInput?.compoundCount > 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Opblandet koncentration i indvinding/fiktiv indvinding:</b>
                                    </label>
                                    <div></div>
                                </div>
                                <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                    <label
                                        for="polutant">{{calculationInput?.degradationChainCompoundNames[i]}}:</label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getNumberWithSignificantDigits(calculation?.calculationResult.pointResults[1].wellConcentration[i])}}
                                            µg/L</span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="calculationInput?.compoundCount == 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Opblandet koncentration i indvinding/fiktiv indvinding:</b>
                                    </label>
                                    <div>
                                        <span *ngIf="pointResults"
                                            class="readonly">{{getNumberWithSignificantDigits(calculation?.calculationResult.pointResults[1].wellConcentration[0])}}
                                            µg/L</span>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="spacer"></div>

                            <ng-container *ngIf="calculationInput?.compoundCount > 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Kvalitetskriterie:</b>
                                    </label>
                                    <div></div>
                                </div>
                                <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                    <label
                                        for="polutant">{{calculationInput?.degradationChainCompoundNames[i]}}:</label>
                                    <div>
                                        <span class="readonly">
                                            {{getValidNumber(calculationInput?.degradationChainQualityCriteria[i]) | number:'1.0-5'}}
                                            µg/L
                                            {{displayAsteriskMark(calculationInput?.degradationChainQualityCriteriaType, i)}}
                                        </span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="calculationInput?.compoundCount == 1">
                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Kvalitetskriterie{{displayAsteriskMark(calculationInput?.degradationChainQualityCriteriaType)}}:</b>
                                    </label>
                                    <div>
                                        <span class="readonly">
                                            {{getValidNumber(calculationInput?.degradationChainQualityCriteria[0]) | number:'1.0-5'}}
                                            µg/L
                                        </span>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="spacer"></div>

                            <div class="form-group">
                                <label for="polutant">Risikovurdering:</label>
                                <div>
                                    <div *ngIf="pointResultIsRisk(1)">
                                        <span class="fa-stack risk-indicator risk-computed">
                                            <span class="icon"></span>
                                        </span>
                                        <span class="readonly">
                                            <b>Risiko</b>
                                        </span>
                                    </div>

                                    <div *ngIf="!pointResultIsRisk(1)">
                                        <span class="fa-stack risk-indicator no-risk-computed">
                                            <span class="icon"></span>
                                        </span>
                                        <span class="readonly">Ingen Risiko</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>


                <div [hidden]="!calculationComplete" #pdfPlumeConcentrationPlotDiv>
                    <h4 class="calculation-section-header mt-5 mb-4">
                        <span i18n> <i class="fa fa-flask"></i> Koncentrationer</span>
                    </h4>

                    <div class="vd-card p-4">
                        <div style="display:inline-block">
                            <div class="helper-img-sm-container">
                                <div class="helper-img-sm"
                                    style="background-image: url('/assets/HorizontalPlumeConcentration2.png');"></div>
                            </div>
                            <div>
                                <h5 i18n>Koncentration langs fanen</h5>
                                <p i18n>Figuren viser koncentrationerne langs fanen (x-aksen). De viste koncentrationer
                                    er midlede koncentrationer
                                    over den valgte filterlængde, og er beregnet for dybderne med de højeste
                                    koncentrationer.
                                    Nulpunktet på x-aksen angiver placeringen af forureningskildens nedstrøms kant.</p>
                            </div>
                        </div>
                        <div #HorizontalPlumeConcentrationPlotContainer class=" mt-3">
                            <div class="lengend mb-1">
                                <span *ngFor="let legend of horizontalPlumeConcentrationLegend"
                                    (click)="toggleGraph(legend)" data-toggle="tooltip" data-placement="top"
                                    title="{{legend.toolTip}}">
                                    <i class="fa fa-lg"
                                        [ngClass]="{ 'fa-minus-square-o':!legend.isActive, 'fa-check-square': legend.isActive}"
                                        [ngStyle]="{color: legend.color}"></i> {{legend.name}}
                                </span>
                            </div>
                            <div class="point-sample-result-group">
                                <div #HorizontalPlumeConcentrationPlotDiv=""></div>
                            </div>
                            <!--<canvas id="horizontalPlumeConcentrationCanvas">{{ horizontalPlumeConcentrationChart }}</canvas>-->
                        </div>
                    </div>
                </div>

                <div class="mt-5" [hidden]="!calculationComplete" #pdfPlumeConcentrationAtPoCPlotDiv>
                    <div class="vd-card p-4">
                        <div style="display:inline-block">
                            <div class="helper-img-sm-container">
                                <div class="helper-img-sm"
                                    style="background-image: url('/assets/ConcentrationDownstream2.png')"></div>
                            </div>

                            <h5 i18n>Koncentrationen over dybden i kontrolpunktet {{plotPointDist}} m nedstrøms</h5>
                            <p i18n>Figuren viser koncentrationens variation over dybden i en nedstrøms afstand svarende
                                til det kontrolpunkt,
                                der kigges på.</p>

                        </div>
                        <div #PlumeConcentrationAtPoCPlotContainer class="mt-3">
                            <div class="lengend mb-1">
                                <span *ngFor="let legend of plumeConcentrationAtPoCPlotLegend"
                                    (click)="toggleGraph(legend)" data-toggle="tooltip" data-placement="top"
                                    title="{{legend.toolTip}}">
                                    <i class="fa fa-lg"
                                        [ngClass]="{ 'fa-minus-square-o':!legend.isActive, 'fa-check-square': legend.isActive}"
                                        [ngStyle]="{color: legend.color}"></i> {{legend.name}}
                                </span>
                            </div>
                            <!--<canvas id="plumeConcentrationAtPoCCanvas">{{ plumeConcentrationAtPoCChart }}</canvas>-->
                            <div class="point-sample-result-group">
                                <div #PlumeConcentrationAtPoCPlotDiv=""></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5"
                    [hidden]="(!calculation) || (!calculationComplete) || (calculation?.calculationInput?.modelType == calculationModelType.ModelV) || plotPointResult == null || plotPointResult.verticalModelOutput[0].x == null"
                    #pdfConcentrationPlotDiv>

                    <div class="vd-card p-4">
                        <div style="display:inline-block">
                            <div class="helper-img-sm-container">
                                <div class="helper-img-sm"
                                    style="background-image: url('/assets/VerticalConcentration2.png')"></div>
                            </div>

                            <h5 i18n>Koncentration over grundvandsspejlet</h5>
                            <p i18n>Figuren viser koncentrationens variation over dybden fra forureningskilden og ned
                                til grundvandsspejlet.</p>

                        </div>
                        <div #VerticalConcentrationPlotDivContainer class="mt-3">
                            <div class="lengend mb-1">
                                <span *ngFor="let legend of verticalConcentrationPlotLegend"
                                    (click)="toggleGraph(legend)" data-toggle="tooltip" data-placement="top"
                                    title="{{legend.toolTip}}">
                                    <i class="fa fa-lg"
                                        [ngClass]="{ 'fa-minus-square-o':!legend.isActive, 'fa-check-square': legend.isActive}"
                                        [ngStyle]="{color: legend.color}"></i> {{legend.name}}
                                </span>
                            </div>
                            <!--<canvas id="verticalModelOutputCanvas">{{ verticalModelOutputChart }}</canvas>-->
                            <div class="point-sample-result-group">
                                <div #VerticalConcentrationPlotDiv=""></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5" id="pdfAquiferTopConcentrationPlotDiv"
                    [hidden]="(!calculation) || (!calculationComplete) || (calculation?.calculationInput?.modelType != calculationModelType.ModelIII && calculation?.calculationInput?.modelType != calculationModelType.ModelIV)"
                    #pdfAquiferTopConcentrationPlotDiv>

                    <div class="vd-card p-4">
                        <div style="display:inline-block">
                            <div class="helper-img-sm-container">
                                <div class="helper-img-sm"
                                    style="background-image: url('/assets/AquiferConcentration2.png')"></div>
                            </div>
                            <div>

                                <h5 i18n>Koncentrationen ved toppen af grundvandet</h5>
                                <p i18n>Figuren viser forureningskoncentrationens variation lige over grundvandsspejlet.
                                </p>
                            </div>
                        </div>
                        <div #AquiferTopConcentrationPlotContainer class="mt-3">
                            <div class="lengend mb-1">
                                <span *ngFor="let legend of aquiferTopConcentrationPlotLegend"
                                    (click)="toggleGraph(legend)" data-toggle="tooltip" data-placement="top"
                                    title="{{legend.toolTip}}">
                                    <i class="fa fa-lg"
                                        [ngClass]="{ 'fa-minus-square-o':!legend.isActive, 'fa-check-square': legend.isActive}"
                                        [ngStyle]="{color: legend.color}"></i> {{legend.name}}
                                </span>
                            </div>
                            <div class="point-sample-result-group">
                                <div #AquiferTopConcentrationPlotDiv=""></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12 col-lg-2 mt-3">
            <div class="v-rule"></div>
        </div>

        <div class="col-sm-12 col-lg-4 ml-auto">
            <h5 class="calculation-section-header">
                <span i18n>
                    <i class="fa fa-gear"></i> Valgmuligheder</span>
            </h5>

            <div class="form-group mt-3">

                <label for="export">Eksporter:</label>
                <div class="dropdown input-label " id="export" [class]="{'eksport-disabled': !calculationComplete}">
                    <a class="btn btn-outline-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Vælg format
                    </a>

                    <div class="dropdown-menu " aria-labelledby="dropdownMenuLink">
                        <a class="dropdown-item" id="btnDownloadPdf" (click)="downloadPdf()">PDF</a>
                        <a class="dropdown-item" id="btnDownloadCSV" (click)="downloadCSV()">CSV</a>
                    </div>
                </div>
            </div>

            <div *ngIf="calculation" class="button-group">
                <div>
                    <button (click)="newCalculation()" class="btn btn-outline-secondary">
                        <span class="fa fa-refresh fa-lg"></span> Ny beregning</button>
                </div>
                <div>
                    <button class="btn btn-outline-secondary" data-toggle="modal" data-target="#modalParameterListView"
                        id="toggleParameterListViewButton">
                        <span class="fa fa-list fa-lg"></span> Se parameterliste</button>
                </div>
                <div *ngIf="calculation.calculationType == calculationType.Standard">
                    <button data-toggle="modal" data-target="#modalApproveCalculation" *ngIf="!calculationIsApproved"
                        [disabled]="!calculationComplete" class="btn btn-outline-secondary">
                        <span class="fa fa-check fa-lg"></span>
                        Godkend beregning
                    </button>
                    <button data-toggle="modal" data-target="#modalUnapproveCalculation" *ngIf="calculationIsApproved"
                        [disabled]="!calculationComplete" class="btn btn-outline-secondary">
                        <span class="fa fa-times fa-lg"></span>
                        Fjern godkendelse
                    </button>
                </div>
            </div>

            <h5 class="calculation-section-header mt-5">
                <span i18n>
                    <i class="fa fa-comment-o"></i> Noter</span>
            </h5>
            <div *ngIf="calculation" class="mt-4">
                <p *ngIf="calculation.comments.length == 0" class="text-muted">Ingen noter tilføjet</p>
                <div *ngFor="let comment of calculation.comments" class="note-item">
                    <div class="note-connector-line">
                        <div class="note-connector-marker"></div>
                    </div>
                    <div class="message-area pb-4">
                        <div class="date-badge">
                            <span class="text-muted">{{comment.timeStamp | date:'d/M-yyyy HH:mm'}} -
                                <i class="fa fa-user"></i>
                            </span>
                            <b>{{comment.owner}}</b>
                        </div>
                        <div class="note-item-wrapper">
                            <b *ngIf="comment.category">{{commentCategoryHeaderText.get(comment.category)}}:
                                <br /> </b>
                            {{comment.text}}
                        </div>
                    </div>
                </div>

                <div class="note-item add-new">
                    <div class="note-connector-line">
                        <div class="note-connector-marker"></div>
                    </div>
                    <div class="message-area">
                        <label for="exampleFormControlTextarea1" class="text-muted">Tilføj ny note:</label>
                        <div class="note-input">
                            <textarea class="form-control" id="exampleFormControlTextarea1" placeholder="Skriv note..."
                                rows="2" [(ngModel)]="commentText"></textarea>
                            <button class="btn btn-outline-secondary btn-sm" [disabled]="!commentText"
                                (click)="addComment()">Tilføj
                                <span class="fa fa-paper-plane-o"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="modalApproveCalculation" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Godkend beregning</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <textarea #approvalMessage class="form-control" placeholder="Tilføj note..." rows="2"></textarea>
                </div>
                <div class="modal-footer">
                    <button (click)="approve(approvalMessage.value)" type="button" class="btn btn-primary"
                        data-dismiss="modal">Godkend</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fortryd</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="modalUnapproveCalculation" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Fjern godkendelse</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <textarea #unapprovalMessage class="form-control" placeholder="Tilføj note..." rows="2"></textarea>
                </div>
                <div class="modal-footer">
                    <button (click)="unapprove(unapprovalMessage.value)" type="button" class="btn btn-primary"
                        data-dismiss="modal">OK</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fortryd</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="modalParameterListView" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Parameterliste</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <!-- Forureningskilde -->
                            <div #pdfForureningskildeParametersDiv class="point-sample-result-group mx-auto w-100">
                                <h6 class="calculation-section-header">
                                    <span i18n>Forureningskilde</span>
                                </h6>

                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Kildekoncentration:</b>
                                    </label>
                                    <div></div>
                                </div>
                                <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                    <label
                                        for="polutant">{{calculationInput?.degradationChainCompoundNames[i]}}:</label>
                                    <div>
                                        <span
                                            class="readonly">{{calculationInput?.sourceConcentration[i] | number:'1.0-10'}}
                                            µg/L</span>
                                    </div>
                                </div>
                                <div class="spacer"></div>

                                <ng-container *ngIf="(calculationInput?.modelType != calculationModelType.ModelIV)">
                                    <div class="form-group">
                                        <label for="polutant">
                                            <b>Længde af kilde:</b>
                                        </label>
                                        <div>
                                            <span class="readonly">{{calculationInput?.sourceLength | number:'1.0-10'}}
                                                m</span>
                                        </div>
                                    </div>
                                    <div class="spacer"></div>
                                </ng-container>

                                <ng-container *ngIf="(calculationInput?.modelType != calculationModelType.ModelIV)">
                                    <div class="form-group">
                                        <label for="polutant">
                                            <b>Bredde af kilde:</b>
                                        </label>
                                        <div>
                                            <span class="readonly">{{calculationInput?.sourceWidth | number:'1.0-10'}}
                                                m</span>
                                        </div>
                                    </div>
                                    <div class="spacer"></div>
                                </ng-container>

                                <ng-container *ngIf="(calculationInput?.modelType != calculationModelType.ModelIV)">
                                    <div class="form-group">
                                        <label for="polutant">
                                            <b>Infiltration i kildeområde:</b>
                                        </label>
                                        <div>
                                            <span
                                                class="readonly">{{calculationInput?.sourceInfiltration | number:'1.0-10'}}
                                                mm/år</span>
                                        </div>
                                    </div>
                                    <div class="spacer"></div>
                                </ng-container>

                                <ng-container *ngIf="(calculationInput?.modelType == calculationModelType.ModelIV)">
                                    <div class="form-group">
                                        <label for="polutant">
                                            <b>Radius af kildeområde:</b>
                                        </label>
                                        <div>
                                            <span class="readonly">{{calculationInput?.sourceRadius | number:'1.0-10'}}
                                                m</span>
                                        </div>
                                    </div>
                                    <div class="spacer"></div>
                                </ng-container>

                                <ng-container
                                    *ngIf="(calculationInput?.modelType == calculationModelType.ModelIV && calculationInput?.degradation == degradation.None)">
                                    <div class="form-group">
                                        <label for="polutant">
                                            <b>Grænseradius, hvor koncentrationen antages lig nul:</b>
                                        </label>
                                        <div>
                                            <span
                                                class="readonly">{{calculationInput?.concentrationZeroRadius | number:'1.0-10'}}
                                                m</span>
                                        </div>
                                    </div>
                                    <div class="spacer"></div>
                                </ng-container>

                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Infiltration over fanen:</b>
                                    </label>
                                    <div>
                                        <span class="readonly">{{calculationInput?.plumeInfiltration | number:'1.0-10'}}
                                            mm/år</span>
                                    </div>
                                </div>
                                <div class="spacer"></div>
                            </div>

                            <!-- Vertikal transport -->
                            <div #pdfVerticalTransportParametersDiv class="point-sample-result-group mx-auto w-100">

                                <ng-container *ngIf="(calculationInput?.modelType != calculationModelType.ModelV)">
                                    <div class="spacer"></div>
                                    <h6 class="calculation-section-header">
                                        <span i18n>Vertikal transport</span>
                                    </h6>

                                    <ng-container *ngIf="(calculationInput?.modelType != calculationModelType.ModelIV)">
                                        <div class="form-group">
                                            <label for="polutant">
                                                <b>Afstand fra kilde til top af grundvandsmagasin:</b>
                                            </label>
                                            <div>
                                                <span
                                                    class="readonly">{{calculationInput?.sourceToAquiferDist | number:'1.0-10'}}
                                                    m</span>
                                            </div>
                                        </div>
                                        <div class="spacer"></div>
                                    </ng-container>

                                    <ng-container *ngIf="(calculationInput?.modelType == calculationModelType.ModelIV)">
                                        <div class="form-group">
                                            <label for="polutant">
                                                <b>Kapillarzonens dybde:</b>
                                            </label>
                                            <div>
                                                <span
                                                    class="readonly">{{calculationInput?.capillaryFringe | number:'1.0-10'}}
                                                    m</span>
                                            </div>
                                        </div>
                                        <div class="spacer"></div>
                                    </ng-container>

                                    <div class="form-group">
                                        <label for="polutant">
                                            <b>Porøsitet:</b>
                                        </label>
                                        <div>
                                            <span
                                                class="readonly">{{calculationInput?.verticalPorosity | number:'1.0-10'}}</span>
                                        </div>
                                    </div>
                                    <div class="spacer"></div>

                                    <ng-container
                                        *ngIf="(calculationInput?.modelType == calculationModelType.ModelIII || calculationInput?.modelType == calculationModelType.ModelIV)">
                                        <div class="form-group">
                                            <label for="polutant">
                                                <b>Vandindhold:</b>
                                            </label>
                                            <div>
                                                <span
                                                    class="readonly">{{calculationInput?.waterContent | number:'1.0-10'}}</span>
                                            </div>
                                        </div>
                                        <div class="spacer"></div>
                                    </ng-container>

                                    <ng-container *ngIf="(calculationInput?.modelType != calculationModelType.ModelIV)">
                                        <div class="form-group">
                                            <label for="polutant">
                                                <b>Longitudinal dispersivitet (z-retning):</b>
                                            </label>
                                            <div>
                                                <span class="readonly">
                                                    {{calculationInput?.verticalLongitudinalDispersivity | number:'1.0-10'}}
                                                    m
                                                </span>
                                            </div>
                                        </div>
                                        <div class="spacer"></div>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="(calculationInput?.modelType == calculationModelType.ModelIII)">
                                        <div class="form-group">
                                            <label for="polutant">
                                                <b>Transversal dispersivitet (y-retning):</b>
                                            </label>
                                            <div>
                                                <span
                                                    class="readonly">{{calculationInput?.verticalTransversalDispersivity | number:'1.0-10'}}
                                                    m</span>
                                            </div>
                                        </div>
                                        <div class="spacer"></div>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="((calculationInput?.modelType == calculationModelType.ModelI) || (calculationInput?.modelType == calculationModelType.ModelII))">
                                        <div class="form-group">
                                            <label for="polutant">
                                                <b>1. ordens nedbrydningsrate:</b>
                                            </label>
                                            <div></div>
                                        </div>
                                        <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                            <label
                                                for="polutant">{{calculationInput?.degradationChainCompoundNames[i]}}:</label>
                                            <div>
                                                <span class="readonly">
                                                    {{calculationInput?.verticalFirstOrderDegradationRate[i] | number:'1.0-10'}}
                                                    d
                                                    <sup>-1</sup>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="spacer"></div>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="((calculationInput?.modelType == calculationModelType.ModelIII) || (calculationInput?.modelType == calculationModelType.ModelIV))">
                                        <div class="form-group">
                                            <label for="polutant">
                                                <b>1. ordens nedbrydningsrate, {{calculationInput.contaminantName}}:</b>
                                            </label>
                                            <div>
                                                <span class="readonly">
                                                    {{calculationInput?.verticalFirstOrderDegradationRate[0] | number:'1.0-10'}}
                                                    d
                                                    <sup>-1</sup>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="spacer"></div>
                                    </ng-container>

                                    <ng-container *ngIf="(calculationInput?.modelType == calculationModelType.ModelII)">
                                        <div class="form-group">
                                            <label for="polutant">
                                                <b>Sprækkeafstand:</b>
                                            </label>
                                            <div>
                                                <span
                                                    class="readonly">{{calculationInput?.fractureSpacing | number:'1.0-10'}}
                                                    m</span>
                                            </div>
                                        </div>
                                        <div class="spacer"></div>
                                    </ng-container>

                                    <ng-container *ngIf="(calculationInput?.modelType == calculationModelType.ModelII)">
                                        <div class="form-group">
                                            <label for="polutant">
                                                <b>Sprækkeapertur:</b>
                                            </label>
                                            <div>
                                                <span
                                                    class="readonly">{{calculationInput?.fractureAperture | number:'1.0-10'}}
                                                    m</span>
                                            </div>
                                        </div>
                                        <div class="spacer"></div>
                                    </ng-container>

                                    <ng-container *ngIf="(calculationInput?.modelType == calculationModelType.ModelII)">
                                        <div class="form-group">
                                            <label for="polutant">
                                                <b>Bulk hydraulisk konduktivitet:</b>
                                            </label>
                                            <div>
                                                <span
                                                    class="readonly">{{calculationInput?.bulkHydraulicConductivity | number:'1.0-10'}}
                                                    m/s</span>
                                            </div>
                                        </div>
                                        <div class="spacer"></div>
                                    </ng-container>

                                </ng-container>
                            </div>

                            <!-- Horisontal transport -->
                            <div #pdfHorizontalTransportParametersDiv class="point-sample-result-group mx-auto w-100">
                                <div class="spacer"></div>
                                <h6 class="calculation-section-header">
                                    <span i18n>Horisontal transport</span>
                                </h6>

                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Mægtighed af grundvandsmagasinet (fra top til bund):</b>
                                    </label>
                                    <div>
                                        <span class="readonly">{{calculationInput?.aquiferThickness | number:'1.0-10'}}
                                            m</span>
                                    </div>
                                </div>
                                <div class="spacer"></div>

                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Grundvandshastighed:</b>
                                    </label>
                                    <div>
                                        <span
                                            class="readonly">{{calculationInput?.groundwaterVelocity | number:'1.0-2'}}
                                            m/år</span>
                                    </div>
                                </div>
                                <div class="spacer"></div>

                                <ng-container *ngIf="calculationInput?.calculateGroundwaterVelocity">
                                    <div class="form-group">
                                        <label for="polutant">
                                            <b>Hydraulisk konduktivitet:</b>
                                        </label>
                                        <div>
                                            <span
                                                class="readonly">{{calculationInput?.hydraulicConductivity | number:'1.0-10'}}
                                                m/s</span>
                                        </div>
                                    </div>
                                    <div class="spacer"></div>

                                    <div class="form-group">
                                        <label for="polutant">
                                            <b>Hydraulisk gradient:</b>
                                        </label>
                                        <div>
                                            <span
                                                class="readonly">{{calculationInput?.hydraulicGradient | number:'1.0-10'}}</span>
                                        </div>
                                    </div>
                                    <div class="spacer"></div>
                                </ng-container>

                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Porøsitet:</b>
                                    </label>
                                    <div>
                                        <span
                                            class="readonly">{{calculationInput?.horizontalPorosity | number:'1.0-10'}}</span>
                                    </div>
                                </div>
                                <div class="spacer"></div>

                                <div class="form-group">
                                    <label for="polutant">
                                        <b>1. ordens nedbrydningsrate:</b>
                                    </label>
                                    <div></div>
                                </div>
                                <div class="form-group" *ngFor="let i of degradationCompoundIndices">
                                    <label
                                        for="polutant">{{calculationInput?.degradationChainCompoundNames[i]}}:</label>
                                    <div>
                                        <span class="readonly">
                                            {{calculationInput?.horizontalFirstOrderDegradationRate[i] | number:'1.0-10'}}
                                            d
                                            <sup>-1</sup>
                                        </span>
                                    </div>
                                </div>
                                <div class="spacer"></div>

                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Longitudinal dispersivitet (x-retning):</b>
                                    </label>
                                    <div>
                                        <span
                                            class="readonly">{{calculationInput?.horizontalLongitudinalDispersivity | number:'1.0-10'}}
                                            m</span>
                                    </div>
                                </div>
                                <div class="spacer"></div>

                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Transversal dispersivitet (y-retning):</b>
                                    </label>
                                    <div>
                                        <span
                                            class="readonly">{{calculationInput?.horizontalTransversalDispersivity | number:'1.0-10'}}
                                            m</span>
                                    </div>
                                </div>
                                <div class="spacer"></div>

                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Vertikal dispersivitet (z-retning):</b>
                                    </label>
                                    <div>
                                        <span
                                            class="readonly">{{calculationInput?.horizontalVerticalDispersivity | number:'1.0-10'}}
                                            m</span>
                                    </div>
                                </div>
                                <div class="spacer"></div>
                            </div>

                            <!-- Kontrolpunkter -->
                            <div #pdfKontrolpunkterParametersDiv class="point-sample-result-group mx-auto w-100">
                                <div class="spacer"></div>
                                <h6 class="calculation-section-header">
                                    <span i18n>Kontrolpunkter</span>
                                </h6>

                                <div class="form-group">
                                    <label>
                                        <b>
                                            Der regnes altid i et administrativt punkt i afstand 100 m målt fra
                                            forureningskildens
                                            nedstrøms kant og med en filterlængde på 2m.
                                        </b>
                                    </label>
                                </div>
                                <div class="spacer"></div>

                                <ng-container *ngIf="(calculationInput?.hasAdditionalPoC)">
                                    <div class="form-group">
                                        <label for="polutant">
                                            <b>Valgfrit kontrolpunkt:</b>
                                        </label>
                                        <div></div>
                                    </div>

                                    <div class="form-group">
                                        <label for="polutant">
                                            <b>Afstand fra kilde til nedstrøms kontrolpunkt:</b>
                                        </label>
                                        <div>
                                            <span
                                                class="readonly">{{calculationInput?.additionalPoCDistanceFromSource | number:'1.0-10'}}
                                                m</span>
                                        </div>
                                    </div>
                                    <div class="spacer"></div>

                                    <div class="form-group">
                                        <label for="polutant">
                                            <b>Filterlængde som koncentrationen i kontrolpunktet midles over:</b>
                                        </label>
                                        <div>
                                            <span
                                                class="readonly">{{calculationInput?.additionalPoCScreenLength | number:'1.0-10'}}
                                                m</span>
                                        </div>
                                    </div>
                                    <div class="spacer"></div>
                                </ng-container>

                                <div class="form-group">
                                    <label for="polutant">
                                        <b>Indvindingsrate ved nærmeste indvinding:</b>
                                    </label>
                                    <div>
                                        <span class="readonly">
                                            {{calculationInput?.abstractionRate | number:'1.0-10'}} m
                                            <sup>3</sup>/år
                                        </span>
                                    </div>
                                </div>
                                <div class="spacer"></div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="dismissParameterListViewButton" class="btn btn-secondary"
                        data-dismiss="modal">Luk</button>
                </div>
            </div>
        </div>
    </div>
</div>